/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useRef } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import Image from 'next/image';
import map from 'lodash/map';
import slice from 'lodash/slice';

import VideoWithThumbnail from 'components/VideoWithThumbnail';

const DesktopSlider = ({ setGalleryContent, medias }) => {
  const sliderRef = useRef();

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const slideNext = () => {
    sliderRef.current.slickNext();
  };

  const slidePrevious = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <div className="im-box im-box--white im-box--border-radius im-box--list-item im-box--padding-sm-15 d-none d-lg-block">
      <div className="im-image-gallery im-product-gallery">
        <div className="im-image-gallery__view">
          <div className="im-slider-container product-detail-page-slider">
            <div className="im-slider im-image-gallery__view__slider product-gallery-slider">
              <Slider {...sliderSettings} ref={sliderRef}>
                {
                  medias.length > 0
                    ? map(medias, (media, index) => (
                      <div
                        onClick={() => setGalleryContent({ medias, showIndex: index })}
                        className="product-gallery-slider__item"
                        key={index}
                      >
                        {media.type === 'video' ? (
                          <VideoWithThumbnail
                            video={media}
                            width="640px"
                            height="480px"
                            notPlayable
                          />
                        ) : (
                          <Image
                            src={media.main}
                            width="640"
                            height="480"
                          />
                        )}
                      </div>
                    ))
                    : (
                      <div className="product-gallery-slider__item">
                        <Image
                          src="/image/machine-detail-slider-placeholder.jpg"
                          width="640"
                          height="480"
                        />
                      </div>
                    )
                }
              </Slider>
            </div>
            <div className="im-slider__arrows">
              <div className="im-slider__arrows__prev" onClick={() => slidePrevious()}>
                <i className="fa-solid fa-angle-left" />
              </div>
              <div className="im-slider__arrows__next" onClick={() => slideNext()}>
                <i className="fa-solid fa-angle-right" />
              </div>
            </div>
          </div>
        </div>
        <div className="im-image-gallery__nav d-none d-md-block">
          <div className="row">
            {map(slice(medias, 0, 4), (media, index) => (
              <div
                className="col-3 im-image-gallery__nav__item-grid"
                key={index}
                onClick={() => sliderRef.current.slickGoTo(index)}
              >
                <a className="im-image-gallery__nav__item">
                  {media.type === 'video' ? (
                    <VideoWithThumbnail
                      video={media}
                      layout="fill"
                      objectFit="cover"
                      notPlayable
                      smallerPlayButton
                    />
                  ) : (
                    <Image
                      src={media.thumbnail}
                      layout="fill"
                      objectFit="cover"
                    />
                  )}
                </a>
              </div>
            ))}
            {
              medias.length > 4
              && (
                <div
                  className="col-3 im-image-gallery__nav__item-grid"
                  onClick={() => setGalleryContent({ medias })}
                >
                  <a className="im-image-gallery__nav__item im-image-gallery__nav__item--overlay" data-ig-nav-open-detail="true">
                    <div className="im-image-gallery__nav__item__overlay">
                      {medias.length}
                    </div>
                  </a>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

DesktopSlider.propTypes = {
  setGalleryContent: PropTypes.func,
  medias: PropTypes.array,
};

export default DesktopSlider;
